import { Injectable } from '@angular/core';

@Injectable()
export class GetFileTypeService {

  constructor() { }

  // we should consider adding in some potential security here that will deny unwanted file types
  // Lets consider/discuss making FileSizeString and FileType a separate service that gets called.
  getFileTypeFromExtension(filename) {
    if (!filename) {
      return 0;
    }
    let fileparts = filename.split('.');
    if (fileparts.length < 2) {
      return 0;
    }
    let ext = fileparts.pop();

    // This is to account for part filenames that have multiple extensions
    // e.g. *.prt.*
    let preext = '';
    if (fileparts.length > 1) {
      preext = fileparts.pop();
      preext = preext.toLowerCase();
    }

    ext = ext.toLowerCase();

    switch (ext) {

      case '3dxml':
      case 'ipt':
      case 'catpart':
      case 'igs':
      case 'iges':
      case 'jt':
      case 'x_t':
      case 'x_b':
      case 'prc':
      case 'prt':
      case '3dm':
      case 'sat':
      case 'sab':
      case 'par':
      case 'sldprt':
      case 'stp':
      case 'step':
      case 'stl':
      case 'u3d':
      case 'obj':
      case 'hwf':
      case 'dxf':
      case 'dwg':
      case 'wrl': {
        return 1;
      }
      case 'pdf': {
        return 2;
      }
      case 'xls':
      case 'xlsx':
      case 'xlsm':
      case 'csv': {
        return 3;
      }
      case 'zip': {
        return 4;
      }
      case 'doc':
      case 'docx':
      case 'txt': {
        return 5;
      }
      case 'ppt':
      case 'pptx': {
        return 6;
      }
      case 'png': {
        return 7;
      }
      case 'jpg':
      case 'jpeg': {
        return 8;
      }
      case 'gif': {
        return 9;
      }
      case 'tiff': {
        return 10;
      }
      case 'html':
      case 'htm':
      case 'xml': {
        return 11;
      }
      default: {
        return 0;
      }
    }
  }
  returnFileTypeExtensionURL(ext) {
    //  this.quoteprojects[key].thumbnail = this.localServiceName.attachFileURLService(ext) this returns the string '/assets/images/doctypes/****.png'
    switch (ext) {
      case 'pdf': {
        return '/assets/images/doctypes/pdf.png';
      }
      case 'doc':
      case 'docx': {
        return '/assets/images/doctypes/doc.png';
      }
      case 'xls':
      case 'xlsx': {
        return '/assets/images/doctypes/xls.png';
      }
      case 'ppt':
      case 'pptx': {
        return '/assets/images/doctypes/ppt.png';
      }
      case 'gif':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'tiff':
      case 'tif': {
        return '/assets/images/doctypes/img.png';
      }
      case 'iso':
      case 'tar':
      case 'gz':
      case '7z':
      case 'cab':
      case 'rar':
      case 'sit':
      case 'tar':
      case 'zip': {
        return '/assets/images/doctypes/zip.png';
      }
      default: {
        return '/assets/images/doctypes/file.png';
      }
    }
  }
// quote component has no 96
 // // this chunk is a perfect example of something to be abstracted out of this component
        // // maybe an additional service or a separate object file.
        // if (ext === 'pdf') {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/pdf.png';
        // } else if (ext === 'doc' || ext === 'docx') {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/doc.png';
        // } else if (ext === 'xls' || ext === 'xlsx') {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/xls.png';
        // } else if (ext === 'ppt' || ext === 'pptx') {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/ppt.png';
        // } else if (ext === 'gif' || ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'tiff' || ext === 'tif') {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/img.png';
        // } else if (ext === 'iso' || ext === 'tar' || ext === 'gz' || ext === '7z' || ext === 'cab' || ext === 'rar' || ext === 'sit' || ext === 'tar' || ext === 'zip') {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/zip.png';
        // } else {
        //   this.quoteprojects[key].thumbnail = '/assets/images/doctypes/file.png';
        // }
   //  if (ext === 'pdf') {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/pdf96.png';
          // } else if (ext === 'doc' || ext === 'docx') {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/doc96.png';
          // } else if (ext === 'xls' || ext === 'xlsx') {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/xls96.png';
          // } else if (ext === 'ppt' || ext === 'pptx') {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/ppt96.png';
          // } else if (ext === 'gif' || ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'tiff' || ext === 'tif') {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/img96.png';
          // } else if (ext === 'iso' || ext === 'tar' || ext === 'gz' || ext === '7z' || ext === 'cab' || ext === 'rar' || ext === 'sit' || ext === 'tar' || ext === 'zip') {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/zip.png';
          // } else {
          //   myprojectdata.projects[key].thumbnail = '/assets/images/doctypes/file96.png';
          // }

  returnFileTypeExtensionURLAppend96(ext) {
    //  this.quoteprojects[key].thumbnail = this.localServiceName.attachFileURLService(ext) this returns the string '/assets/images/doctypes/****.png'
    switch (ext) {
      case 'pdf': {
        return '/assets/images/doctypes/pdf96.png';
      }
      case 'doc':
      case 'docx': {
        return '/assets/images/doctypes/doc96.png';
      }
      case 'xls':
      case 'xlsx': {
        return '/assets/images/doctypes/xls96.png';
      }
      case 'ppt':
      case 'pptx': {
        return '/assets/images/doctypes/ppt96.png';
      }
      case 'gif':
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'tiff':
      case 'tif': {
        return '/assets/images/doctypes/img96.png';
      }
      case 'iso':
      case 'tar':
      case 'gz':
      case '7z':
      case 'cab':
      case 'rar':
      case 'sit':
      case 'tar':
      case 'zip': {
        // for some reason zips are the only files returned with no 96 appended?
        // project.component for some reason doesn't append 96 to zips and default cases
        // workspace.component doesn't append 96 to zips but all other cases...
        // REVIEW
        return '/assets/images/doctypes/zip96.png';
      }
      default: {
        return '/assets/images/doctypes/file96.png';
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/getFileType/get-file-type.service.ts